export enum ActionType {
  EDIT = "edit",
  CREATE = "create",
  DELETE = "delete",
}
